import { render, staticRenderFns } from "./PhoneHome.vue?vue&type=template&id=744f63ac&scoped=true&"
import script from "./PhoneHome.vue?vue&type=script&lang=js&"
export * from "./PhoneHome.vue?vue&type=script&lang=js&"
import style0 from "./PhoneHome.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PhoneHome.vue?vue&type=style&index=1&id=744f63ac&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "744f63ac",
  null
  
)

export default component.exports